import { getFromLocalStorage } from "../../../../utils/webStorage";
import authHeader from "../../../../services/auth-header";
import { NODE_BASE_URL } from "../../../../config/siteUrls";
import instance from "../../../../services/api";
export default async (
  startTime,
  duration,
  editedVideoName,
  videoPathForTrim
) => {
  const cutDuration = duration - startTime;
  const userId = getFromLocalStorage("currentUserId");
  const data = {
    editedVideoName,
    userId,
    videoPathForTrim,
    startTime,
    cutDuration,
  };
  const response = await instance.post(NODE_BASE_URL + "/video/trim", data, {
    headers: authHeader(),
  });
  return response.data;
};
